import React, { useState, useEffect } from 'react';

const SetupAdmin: React.FC = () => {
  const [error, setError] = useState('');

  useEffect(() => {
    // Always show error message
    setError('Admin creation is currently disabled. Please contact an existing administrator for access.');
  }, []);

  return (
    <div className="admin-setup">
      <h2>Admin Setup</h2>
      <div className="error" style={{ color: 'red', marginBottom: '1rem' }}>
        {error}
      </div>
    </div>
  );
};

export default SetupAdmin; 